export function whichAnimationEnd() {
  const animations = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd'
  };
  let el = document.createElement('div');

  for (const key in animations) {
    if ({}.hasOwnProperty.call(animations, key)) {
      if (el.style[key] !== undefined) {
        el = null;
        return animations[key];
      }
    }
  }
}

export function whichTransitionEnd() {
  const el = document.createElement('div');
  const eventNames = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    transition: 'transitionend'
  };

  for (const transition in eventNames) {
    if (el.style[transition] !== undefined) {
      return eventNames[transition];
    }
  }
}
